const STORAGE_KEY = 'trendive-hot-deal-popup-dismissed';
const OPEN_DELAY_MS = 3000;

function alreadyDismissedThisSession() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

function markDismissed() {
  try {
    sessionStorage.setItem(STORAGE_KEY, 'true');
  } catch (error) {
    // Ignore storage errors (e.g. private browsing)
  }
}

const popup = document.getElementById('hot-deal-popup');

if (popup && !alreadyDismissedThisSession()) {
  popup.addEventListener('dialog:close', markDismissed);

  setTimeout(() => {
    if (typeof popup.showDialog === 'function') {
      popup.showDialog();
    }
  }, OPEN_DELAY_MS);
}
